/**
 * Swiper carousel configuration
 * https://swiperjs.com/
 */

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const slideCount = document.querySelectorAll('.swiper-slide').length;

new Swiper('.swiper-container', {
  // Register modules here (v10+)
  modules: [Navigation, Pagination],

  loop: slideCount >= 4,
  slidesPerView: 1.1,
  centeredSlides: true,

  breakpoints: {
    768: {
      slidesPerView: 2.8,
      centeredSlides: false,
      spaceBetween: 24,
      loop: slideCount >= 3,
    },
    1024: {
      slidesPerView: 3.2,
      centeredSlides: false,
      spaceBetween: 24,
      loop: slideCount >= 4,
    },
    1280: {
      slidesPerView: 4.8,
      centeredSlides: false,
      spaceBetween: 24,
      loop: slideCount >= 5,
    },
    1536: {
      slidesPerView: 5.2,
      centeredSlides: false,
      spaceBetween: 24,
      loop: slideCount >= 6,
    },
    1800: {
      slidesPerView: 6.2,
      centeredSlides: false,
      spaceBetween: 24,
      loop: slideCount >= 7,
    },
  },

  pagination: {
    el: '.swiper-pagination',
  },

  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
});
